import { Stack, Typography } from '@mui/material'
import { type location } from 'core/types'
import LocationIcon from '@mui/icons-material/LocationOnOutlined'
import PrimaryIcon from '@mui/icons-material/TaskAltOutlined'
import InfoIcon from '@mui/icons-material/InfoOutlined'
import TriangleAlertIcon from '@mui/icons-material/ReportProblemOutlined'
import DateRangeIcon from '@mui/icons-material/DateRange'
import ShelterIcon from '@mui/icons-material/NightShelterOutlined'
import AccompaniedIcon from '@mui/icons-material/EscalatorWarningOutlined'
import { SchoolIcon } from 'Assets/SVGs/school'
import { useState, useEffect } from 'react'
import { sendGet } from 'hooks/use-fetch'
import { FormatDateValue } from 'core/Utilities'

interface LocationDisplayProps {
  location: location
  isPrimary?: boolean | undefined
  isHomeless?: boolean | undefined
}

export function LocationDisplay (props: LocationDisplayProps): JSX.Element {
  const [showFlintMessage, setShowFlintMessage] = useState(false)
  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      if (props.location.districtID !== undefined && (props.location.isPrimary ?? true)) {
        const { response } = await sendGet(`/CareNetworkEdit/ShowFlintWaterDisclaimer?districtID=${String(props.location.districtID)}`, {})
        setShowFlintMessage(response === true)
      }
    }
    void fetchData()
  }, [])

  return <Stack direction='column' spacing={1}>
    <Stack direction='row' spacing={1}>
      <LocationIcon />
      <Stack direction='column'>
        <Typography variant='body1' sx={{ overflowWrap: 'break-word' }}>
          {props.location.apartment === '' ? props.location.address : `${props.location.address} - ${props.location.apartment}`}
        </Typography>
        <Typography variant='body1' sx={{ overflowWrap: 'break-word' }}>
          {props.location.city}, {props.location.state} {props.location.zipCode}
        </Typography>
        <Typography variant='body1' sx={{ overflowWrap: 'break-word' }}>
          {props.location.zipCode}
        </Typography>
      </Stack>
    </Stack>
    {props.isPrimary === true && <Stack direction='row' spacing={1}>
      <PrimaryIcon />
      <Typography variant='body1'>Primary Address</Typography>
    </Stack>}
    {props.location.districtName != null && <Stack direction='row' spacing={1}>
      <SchoolIcon size={24} />
      <Stack direction='column'>
        <Typography variant='body1' sx={{ overflowWrap: 'break-word' }}>
          {props.location.districtName}
        </Typography>
        <Typography variant='body1' sx={{ overflowWrap: 'break-word', fontStyle: 'italic' }}>
          {props.location.isdName}
        </Typography>
      </Stack>
    </Stack>}
    {props.isHomeless === true && <Stack direction='column' spacing={1}>
      <Stack direction='row' spacing={1}>
        <TriangleAlertIcon />
        <Typography variant='body1'>Experiencing Homelessness</Typography>
      </Stack>
      <Stack direction='row' spacing={1}>
        <DateRangeIcon />
        <Stack direction='column' spacing={1}>
          <Typography variant='body1'>Starting {FormatDateValue(props.location.startDate)}</Typography>
          {props.location.endDate !== null && <Typography variant='body1'>Ending {FormatDateValue(props.location.endDate)}</Typography>}
        </Stack>
      </Stack>
      <Stack direction='row' spacing={1}>
        <ShelterIcon />
        <Typography variant='body1' sx={{ overflowWrap: 'break-word' }}>{props.location.homelessResidence}</Typography>
      </Stack>
      {props.location.isUnaccompaniedYouth !== null && <Stack direction='row' spacing={1}>
        <AccompaniedIcon />
        <Typography variant='body1' sx={{ overflowWrap: 'break-word' }}>{props.location.isUnaccompaniedYouth ?? false ? 'Is an Unaccompanied Youth' : 'Is not an Unaccompanied Youth'}</Typography>
      </Stack>}
    </Stack>}
    {showFlintMessage && <Stack direction='row' spacing={1}>
      <InfoIcon />
      <Typography variant='body1' sx={{ overflowWrap: 'break-word' }}>This family's address looks like it could be eligible for the Flint Waterline Program. Please provide them more information.</Typography>
    </Stack>}
  </Stack>
}
